import GameObject from '../../GameObject/GameObject';
import { AnimationClipEvent } from '../../System/Animation/AnimationClip';
import BaseCard from '../../Prototype/Level/Card/BaseCard';
import CardSystem, { getCardHandler } from '../../System/Card/CardSystem';
import AnimationTask from './AnimationTask';
import CardComponent from '../../Component/Level/Card';
import { ICardStateTaskData } from '../../State/Card/ICardState';

export interface CardAnimationTaskOptions {
    onComplete: () => void;
}

export default class CardAnimationTask extends AnimationTask {
    private system: CardSystem;
    private taskData: ICardStateTaskData;
    private cards: BaseCard[];
    private completeCallback: () => void;

    constructor(
        taskData: ICardStateTaskData,
        system: CardSystem,
        clipName: string,
        gameObject: GameObject,
        meta?: any,
        skip?: boolean,
        options?: CardAnimationTaskOptions
    ) {
        meta = meta || {};
        meta.system = system;
        super(clipName, gameObject, meta, skip);
        this.taskData = taskData;
        // FIXME: Almost no card animation tasks actually use taskData.cards; is this intended or something that has been forgotten about
        this.cards = this.taskData.cards.map(cardID =>
            system.getCardByID(cardID)
        );
        this.system = system;

        this.animationClip.on(
            AnimationClipEvent.START,
            this.onStart.bind(this)
        );
        this.animationClip.on(
            AnimationClipEvent.COMPLETE,
            this.onComplete.bind(this)
        );
        this.animationClip.on(
            AnimationClipEvent.DESTROY,
            this.onComplete.bind(this)
        );
        this.completeCallback = options?.onComplete;
    }

    private onStart(): void {
        // Set all cards to their previous state.
        for (let i = 0, n = this.cards.length; i < n; i++) {
            this.cards[i].getComponent(CardComponent).animating = true;
        }
    }

    private onComplete(): void {
        this.animationClip.off(AnimationClipEvent.START);
        this.animationClip.off(AnimationClipEvent.COMPLETE);
        this.animationClip.off(AnimationClipEvent.DESTROY);

        if (!this.system.isActive()) return;

        const state = this.system.store.getState();
        // Set all cards to their next state.
        for (let i = 0, n = this.cards.length; i < n; i++) {
            getCardHandler(this.cards[i]).handleStateChange(
                state,
                this.system
            );

            this.cards[i].getComponent(CardComponent).animating = false;
        }
        this.completeCallback?.();
    }
}
